import Axios from "axios";
import { ENVIRONMENT_tYPE } from "components/common/constants/Constant";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchAnnouncementsFailure, fetchAnnouncementsSuccess, saveAnnouncementsFailure, saveAnnouncementsSuccess
} from "../actions/announcement.action";
import * as selectors from './selector';

//worker functions
function* workerFetchAnnouncements(action) {
  try {
    const access_token = yield select(selectors.access_token);
    const moment = require('moment');
    const resp = yield call(
      Axios.get, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ANNOUNCEMENTS_URL_PATH}` + action.payload, {
      headers: {
        Authorization: 'Bearer ' + access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    yield put(fetchAnnouncementsSuccess(resp.data));
  } catch (e) {
    yield put(fetchAnnouncementsFailure(e.message));
  }
}

function* workerSaveAnnouncements(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);
    const envs = action.payload.environment === ENVIRONMENT_tYPE.LIVE && action.payload.isUpdate ? [ENVIRONMENT_tYPE.LIVE, ENVIRONMENT_tYPE.STAGING] : [action.payload.environment];
    const resp = yield all(envs.map(en =>
      call(
        Axios.put, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ANNOUNCEMENTS_URL_PATH}` + 'message/' + en,
        action.payload.Announcements, {
        headers: {
          Authorization: 'Bearer ' + access_token,
          transactionId: 'RCE.SRC.' + moment().unix(),
          requestTimeStamp: moment.utc().toJSON(),
        }
      })));

    yield put(saveAnnouncementsSuccess());
  } catch (e) {
    yield put(saveAnnouncementsFailure(e.message));
  }
}
//Watcher functions
export function* watchSaveAnnouncements() {
  yield takeLatest("SAVE_ANNOUNCEMENTS_START", workerSaveAnnouncements);
}
export function* watchFetchAnnouncements() {
  yield takeLatest("FETCH_ANNOUNCEMENTS_START", workerFetchAnnouncements);
}

